
import { useState } from 'react';
import { reports } from '../../../mocks/transparencyData';

export default function ReportDownload() {
  const [filter, setFilter] = useState<'all' | 'monthly' | 'quarterly'>('all');

  const filteredReports = filter === 'all' 
    ? reports 
    : reports.filter(report => report.type === filter);

  const handleDownload = (reportTitle: string) => {
    alert(`正在下载：${reportTitle}`);
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-4 md:p-8">
      <div className="flex flex-row items-center justify-between mb-4 md:mb-6 gap-2">
        <h2 className="text-base md:text-2xl font-bold text-[#1E1E1E] whitespace-nowrap">报告下载中心</h2>
        <div className="flex gap-1 md:gap-2">
          <button
            onClick={() => setFilter('all')}
            className={`px-2 py-1 md:px-4 md:py-2 rounded-lg text-[10px] md:text-sm font-medium transition-all whitespace-nowrap ${
              filter === 'all'
                ? 'bg-[#2A7A62] text-white'
                : 'bg-[#F9F9F9] text-[#6C6C6C] hover:bg-[#2A7A62]/10'
            }`}
          >
            全部
          </button>
          <button
            onClick={() => setFilter('monthly')}
            className={`px-2 py-1 md:px-4 md:py-2 rounded-lg text-[10px] md:text-sm font-medium transition-all whitespace-nowrap ${
              filter === 'monthly'
                ? 'bg-[#2A7A62] text-white'
                : 'bg-[#F9F9F9] text-[#6C6C6C] hover:bg-[#2A7A62]/10'
            }`}
          >
            月度
          </button>
          <button
            onClick={() => setFilter('quarterly')}
            className={`px-2 py-1 md:px-4 md:py-2 rounded-lg text-[10px] md:text-sm font-medium transition-all whitespace-nowrap ${
              filter === 'quarterly'
                ? 'bg-[#2A7A62] text-white'
                : 'bg-[#F9F9F9] text-[#6C6C6C] hover:bg-[#2A7A62]/10'
            }`}
          >
            季度
          </button>
        </div>
      </div>

      <div className="space-y-2 md:space-y-3">
        {filteredReports.map((report) => (
          <div
            key={report.id}
            className="flex items-center justify-between p-2.5 md:p-4 bg-[#F9F9F9] rounded-lg hover:bg-[#2A7A62]/5 transition-all group gap-2 md:gap-4"
          >
            <div className="flex items-center gap-2 md:gap-4 flex-1 min-w-0">
              <div className="w-8 h-8 md:w-12 md:h-12 bg-[#2A7A62] rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-file-pdf-line text-base md:text-2xl text-white"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-xs md:text-base font-bold text-[#1E1E1E] mb-0.5 md:mb-1 truncate">
                  {report.title}
                </h3>
                {/* 移动端：日期、大小、季度横排显示 */}
                <div className="flex items-center gap-2 md:gap-4 text-[9px] md:text-sm text-[#6C6C6C]">
                  <span className="flex items-center gap-0.5 md:gap-1">
                    <i className="ri-calendar-line text-[10px] md:text-sm"></i>
                    {report.date}
                  </span>
                  <span className="flex items-center gap-0.5 md:gap-1">
                    <i className="ri-file-line text-[10px] md:text-sm"></i>
                    {report.size}
                  </span>
                  <span className="px-1.5 py-0.5 bg-white rounded text-[9px] md:text-xs">
                    {report.type === 'monthly' ? '月度' : '季度'}
                  </span>
                </div>
              </div>
            </div>
            <button
              onClick={() => handleDownload(report.title)}
              className="px-2.5 py-1.5 md:px-4 md:py-2 bg-[#2A7A62] text-white rounded-lg hover:bg-[#2A7A62]/90 transition-all flex items-center justify-center gap-1 md:gap-2 whitespace-nowrap group-hover:scale-105 text-[10px] md:text-base flex-shrink-0"
            >
              <i className="ri-download-2-line text-xs md:text-base"></i>
              <span className="hidden md:inline">下载</span>
            </button>
          </div>
        ))}
      </div>

      {filteredReports.length === 0 && (
        <div className="text-center py-8 md:py-12">
          <i className="ri-file-search-line text-4xl md:text-6xl text-[#E0E0E0] mb-3 md:mb-4"></i>
          <p className="text-xs md:text-base text-[#6C6C6C]">暂无相关报告</p>
        </div>
      )}
    </div>
  );
}
